import React, { Component } from 'react';

import config from './config';

const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = page => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: page,
        ...options
      });
    } else if (window.ga) {
      window.ga('set', {
        page,
        ...options
      });
      window.ga('send', 'pageview', page);
    }
  };

  const HOC = class GATrackerHOC extends Component {
    componentDidMount () {
      const page = this.props.location.pathname;
      trackPage(page);
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render () {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export const initializeTracking = () => {
  if (window && window.location.hostname !== 'localhost') {
    if (config.gaTrackingId && window.gtag) {
      window.gtag('config', config.gaTrackingId);
    } else if (config.gaTrackingId && window.ga) {
      window.ga('create', config.gaTrackingId, 'auto');
    }
  }
};

export const trackEvent = (params) => {
  if (config.gaTrackingId && window.gtag) {
    window.gtag('event', params.action, {
      event_category: params.category,
      event_label: params.label,
      value: params.value
    });
  } else if (config.gaTrackingId && window.ga) {
    window.ga('send', 'event', params.category, params.action, params.label, params.value);
  } else {
    console.log('trackEvent', params);
  }
};

export default withTracker;
